import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const LessonKBSService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_KBS, null, wait).then((data) => {
            callback(data);
        });
    },
    /*ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_KBS + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },*/
};